import { NodeId } from 'ui/workflows/flowchart';
import { WorkflowsRootState } from '../ducks.types';

export const getClonedFromJourney = (state: WorkflowsRootState) =>
  state.workflow?.clonedFromJourney || {};
export const getClonedFromProject = (state: WorkflowsRootState) =>
  getClonedFromJourney(state)?.projectId;
export const getClonedFromJourneyInvalidNodes = (state: WorkflowsRootState) =>
  getClonedFromJourney(state)?.invalidNodes || [];
export const getIsClonedFromJourney = (state: WorkflowsRootState) =>
  !!getClonedFromJourney(state)?.id;
export const getIsClonedNodeInvalid = (state: WorkflowsRootState, nodeId?: NodeId) =>
  nodeId && getClonedFromJourneyInvalidNodes(state)?.includes(nodeId);
